var _path, _rect, _path2, _path3, _rect2, _path4, _rect3, _rect4, _rect5, _path5, _path6, _path7, _path8, _path9, _rect6, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSimplify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.46973,43.46973l1.06054,1.06054,4-4a.74972.74972,0,0,0,0-1.06054l-4-4-1.06054,1.06054L68.18945,39.25H8v1.5H68.18945Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 55.25,
    width: 24,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64,48.75v-1.5H40a.7502.7502,0,0,0-.75.75V64a.7502.7502,0,0,0,.75.75h8v-1.5H40.75V48.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25,64v8h1.5V64.75H72v-1.5H64A.7502.7502,0,0,0,63.25,64Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 64,
    width: 1.5,
    height: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75,64V56.75H32a.7502.7502,0,0,0,.75-.75V48h-1.5v7.25H16a.7502.7502,0,0,0-.75.75v7.25H8v1.5h8A.7502.7502,0,0,0,16.75,64Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47.25,
    width: 16,
    height: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 64,
    width: 1.5,
    height: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 64,
    width: 1.5,
    height: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75,32V24.75H24v-1.5H16a.7502.7502,0,0,0-.75.75v7.25H8v1.5h8A.7502.7502,0,0,0,16.75,32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75,16V8h-1.5v7.25H8v1.5h8A.7502.7502,0,0,0,16.75,16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25,8v8a.7502.7502,0,0,0,.75.75h7.25v14.5H24v1.5h8a.7502.7502,0,0,0,.75-.75V16a.7502.7502,0,0,0-.75-.75H24.75V8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,8V24a.7502.7502,0,0,0,.75.75h8v-1.5H40.75V8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25,24v7.25H40v1.5H56a.7502.7502,0,0,0,.75-.75V24.75H72v-1.5H56A.7502.7502,0,0,0,55.25,24Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 8,
    width: 1.5,
    height: 8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75,16V8h-1.5v7.25H56v1.5h8A.7502.7502,0,0,0,64.75,16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimplify);
export default __webpack_public_path__ + "static/media/icon_simplify.682a6413c1a5fef1ba484171feae6037.svg";
export { ForwardRef as ReactComponent };